import { defineStore } from 'pinia';
import i18n from '@/plugins/i18n.js';

import toast from '@/plugins/sweetalert2.js';

import { ApiGetAccountCurrent } from '@/api/accounts.js';

export const userStore = defineStore({
  id: 'user',
  state: () => {
    return {
      userId: '',
      roleId: '',
      name: '',
      roleName: '',
      email: '',
      enabled: false,
      isLoading: false,
      error: {}
    };
  },
  getters: {
    currenArea() {
      return this.$router?.currentRoute?.value?.meta.key;
    },
    isLogin() {
      return !!this.userId;
    }
  },
  actions: {
    loadingStart() {
      this.isLoading = true;
    },
    loadingEnd() {
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    setErrorMsg(data) {
      this.error = data;
    },
    async getAccountCurrent() {
      const data = await ApiGetAccountCurrent();
      if (!data?.msg) {
        this.userId = data.uuid;
        this.roleId = data.roleId;
        this.name = data.name;
        this.roleName = data.roleName;
        this.email = data.email;
        this.enabled = data.enabled;
      }
    },
    logout() {
      this.userId = '';
      this.roleId = '';
      this.name = '';
      this.roleName = '';
      this.email = '';
      this.enabled = false;
      localStorage.removeItem('_token');
      toast.fire({
        toast: true,
        icon: 'success',
        iconColor: 'green',
        text: i18n.global.t('logout_success')
      });
    }
  }
});
